export default "__VITE_ASSET__CqIGlKLL__"